// extracted by mini-css-extract-plugin
export var columnItem = "_cn-3";
export var columnItemDraggable = "_cn-4";
export var dragHandle = "_cn-0";
export var dragHandleHovered = "_cn-1";
export var dropdown = "_cn-5";
export var dropdownContent = "_cn-7";
export var dropdownInner = "_cn-6";
export var filterDropdownHeader = "_cn-8";
export var icon = "_cn-2";
export var sectionDivider = "_cn-9";